<template>
  <div class="lds-ripple">
    <div class="flex justify-center items-center w-full">
      <div class="bsload bsload1"></div>
      <div class="bsload bsload2"></div>
      <div class="bsload bsload3"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Loading extends Vue {}
</script>

<style scoped>
@keyframes bsload-animate {
  50% {
    background-color: #433eff;
    transform: scale(0.8);
  }
}
.bsload {
  width: 10px;
  height: 10px;
  margin-right: 10px;
  background-color: #ebebff;
  border-radius: 50%;
  animation: bsload-animate 1s infinite;
}
.bsload.bsload2 {
  animation-delay: 0.2s;
}
.bsload.bsload3 {
  animation-delay: 0.4s;
}
</style>
